import * as React from 'react';
import clsx from 'clsx';
import { NavLinkProps, NavLink } from 'react-router-dom';
import { withStyles, WithStyles, generateStaticClassName, createStyles } from '@domonda/ui/styles';
import { svgIconClassName } from '@domonda/ui/SvgIcon';

const styles = createStyles(({ palette, spacing }) => ({
  root: {
    width: '100%',
    justifyContent: 'center',
    fontSize: 16,
    fontWeight: 600,
    padding: spacing(0.25, 1),
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: 3,
    color: palette.textSecondary,
    borderBottom: `3px solid transparent`,
    transition: 'all ease 300ms',
    '&:hover, &:active': {
      color: palette.primary,
      backgroundColor: palette.lightest('primary'),
    },
    [`& .${svgIconClassName}`]: {
      marginRight: spacing(0.75),
    },
  },
  active: {
    borderColor: 'currentColor',
    color: palette.primary,
  },
}));

type Props = NavLinkProps;

export const menuLinkClassName = generateStaticClassName('MenuLink');

const MenuLink: React.FC<Props & WithStyles<typeof styles>> = (props) => {
  const { classes, ...rest } = props;
  return (
    <NavLink
      {...rest}
      className={clsx(menuLinkClassName, classes.root)}
      activeClassName={classes.active}
    />
  );
};

const StyledMenuLink = withStyles(styles)(MenuLink);
export { StyledMenuLink as MenuLink };
